import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { store } from './index'
import { closurePeriodSettingsClient } from '@/clients/closure-period-settings-client'
import { ClosurePeriodSettingsGetRequest, ClosurePeriodSettingsGetResponse } from '@/dtos/closure-period-settings/get'
import { ClosurePeriodSettingDeleteRequest } from '@/dtos/closure-period-settings/delete'
import { ClosurePeriodSettingPostRequest } from '@/dtos/closure-period-settings/post'
import { ClosurePeriodSettingPutRequest } from '@/dtos/closure-period-settings/put'

@Module({ store, dynamic: true, namespaced: true, name: 'closurePeriodSettingsStore' })
class ClosurePeriodSettingsStore extends VuexModule {
  // 休業期間設定一覧取得
  private _closurePeriodSettingsGet: ClosurePeriodSettingsGetResponse = new ClosurePeriodSettingsGetResponse()
  private _closurePeriodSettingsCountGet: number | null = null

  get closurePeriodSettingsGet():ClosurePeriodSettingsGetResponse {
    return this._closurePeriodSettingsGet
  }

  get closurePeriodSettingsCountGet():number | null {
    return this._closurePeriodSettingsCountGet
  }

  @Mutation
  private SET_CLOSURE_PERIOD_SETTINGS_GET(res: ClosurePeriodSettingsGetResponse): void {
    this._closurePeriodSettingsGet = res
    this._closurePeriodSettingsCountGet = res.closurePeriodSettingCount
  }

  @Action
  async fetchClosurePeriodSettings(req: ClosurePeriodSettingsGetRequest): Promise<void> {
    const res = await closurePeriodSettingsClient.getClosurePeriodSettings(req)
    this.SET_CLOSURE_PERIOD_SETTINGS_GET(res)
  }

  // 休業期間設定登録
  @Action
  async postClosurePeriodSetting(req: ClosurePeriodSettingPostRequest): Promise<void> {
    await closurePeriodSettingsClient.postClosurePeriodSetting(req)
  }

  // 休業期間設定削除
  @Action
  async deleteClosurePeriodSetting(req: ClosurePeriodSettingDeleteRequest): Promise<void> {
    await closurePeriodSettingsClient.deleteClosurePeriodSetting(req)
  }

  // 休業期間設定更新
  @Action
  async putClosurePeriodSetting(req: ClosurePeriodSettingPutRequest): Promise<void> {
    await closurePeriodSettingsClient.putClosurePeriodSetting(req)
  }
}

export const closurePeriodSettingsModule = getModule(ClosurePeriodSettingsStore)
